export const VIRTUAL_LOCATION_NAME = 'Online';

export function isVirtualEvent(event) {
  return event?.format === 'virtual';
}

// Virtual events have no venue, so their base capacity is stored on the event.
export function getBaseCapacity(event, location) {
  return location?.capacity ?? event?.capacity ?? 0;
}

export function getEventLocationName(event, location) {
  return isVirtualEvent(event) ? VIRTUAL_LOCATION_NAME : (location?.name || '');
}

// Stand-in location for message templates: the meeting link goes where the address
// normally appears, so default and custom templates include it without edits.
export function getTemplateLocation(event, location) {
  if (!isVirtualEvent(event)) return location;
  return { name: VIRTUAL_LOCATION_NAME, address: event.meeting_url ?? event.meetingUrl ?? '' };
}
